import axios from 'axios'

export default {
  status: () => axios.get('admin/emergency/status'),
  pauseSends: () => axios.post('admin/emergency/pause-sends', {}),
  resumeSends: () => axios.post('admin/emergency/resume-sends', {}),
  pauseSite: () => axios.post('admin/emergency/pause-site', {}),
}
